module.exports = __webpack_public_path__ + "media/AUDIO 11.ce080fce.mp3";